import getApiEnv from './ApiEnv';

global.__SDK_VERSION__ = 'alpha';
export const EVENT_TIMEOUT = 50;

export class ClientConnector {
  _eventQueue = [];
  _eventQueueFns = {};
  _eventQueueTimeout = null;

  constructor(Client, store) {
    this.store = store;
    this.client = new Client({
      apiEnv: getApiEnv(),
      partnerName: 'reactMobile',
      version: global.__SDK_VERSION__,
      events: {
        keepAlive: true,
      },
    });
    global.TCClient = this.client;

    this.client.on('signedIn', (user, auth) => {
      // console.log('signed in', user);
    });

    this.client.on('signedOut', () => {
      // console.log('signed out');
      this.stopListeners();
    });
  }

  _addToQueue = ({ id, fn }) => {
    if (!this._eventQueue.includes(id)) {
      this._eventQueue.push(id);
    }
    this._eventQueueFns[id.toString()] = fn;

    if (this._eventQueueTimeout) {
      clearTimeout(this._eventQueueTimeout);
      this._eventQueueTimeout = null;
    }
    this._eventQueueTimeout = setTimeout(this._processQueue, EVENT_TIMEOUT); //eslint-disable-line scanjs-rules/call_setTimeout
  };

  _processQueue = () => {
    this._eventQueueTimeout = null;

    if (!this._eventQueue.length) {
      return;
    }

    const firstEvent = this._eventQueue.shift();
    this._eventQueueFns[firstEvent.toString()]();
    delete this._eventQueueFns[firstEvent.toString()];

    if (this._eventQueue.length) {
      this._eventQueueTimeout = setTimeout(this._processQueue, EVENT_TIMEOUT); //eslint-disable-line scanjs-rules/call_setTimeout
    }
  };

  handleConversationChange = (resource, conversation) => {
    // console.log('conversation change', conversation);
    this._addToQueue({
      id: `updateConversation-${conversation.id}`,
      fn: () => this.store.dispatch.conversation.updateConversation(conversation),
    });
  };

  handleMessageChange = (resource, message) => {
    // console.log('message change', message);
    this._addToQueue({
      id: `updateMessage-${message.id}`,
      fn: () => this.store.dispatch.messages.updateMessage(message),
    });
  };

  handleMessageDelete = (resource, message) => {
    // console.log('message deleted', message);
    this._addToQueue({
      id: `deleteMessage-${message.id}`,
      fn: () => this.store.dispatch.messages.removeMessage(message),
    });
  };

  selectConversation = conversation => {
    this.startListeners();
    this.store.dispatch.conversation.setConversation(conversation);
    this.client.conversations.selectConversation(conversation.id, {
      anchorPoint: 'FIRST_UNREAD_ITEM',
    });
  };

  startListeners = () => {
    this.client.models.Message.on('afterInject', this.handleMessageChange);
    this.client.models.Message.on('afterEject', this.handleMessageDelete);
    this.client.models.Conversation.on('afterInject', this.handleConversationChange);
    this.client.events.connect();
  };

  stopListeners = () => {
    this.client.models.Message.removeListener('afterInject', this.handleMessageChange);
    this.client.models.Message.removeListener('afterEject', this.handleMessageDelete);
    this.client.models.Conversation.removeListener('afterInject', this.handleConversationChange);
    this.client.events.disconnect();
  };
}
